import React, { useState, useEffect } from "react";
import { auth, db } from "../../firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

import Navbar from "../../components/admin/NavBar";
import Sidebar from "../../components/admin/Sidebar";
import SupportSection from "../../components/admin/Support";
import DashboardSection from "../../components/admin/Dashboard";
import InstituteSection from "../../components/admin/Institute";
import PlansSection from "../../components/admin/Plans";
import Preloader from "../../components/Preloader";
import DBStructure from "../../components/admin/DBStructure";
import Settings from "../../components/admin/SettingsAdmin";


function AdminDashboard() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Auth check
  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        const userDocRef = doc(db, "users", currentUser.uid);
        const userDocSnap = await getDoc(userDocRef);
        if (userDocSnap.exists()) {
          const userData = userDocSnap.data();
          if (userData.role === "admin") {
            setUser(currentUser);
          } else {
            window.location.href = "/sign-in";
          }
        } else {
          console.log("No user document found.");
          window.location.href = "/sign-in";
        }
      } else {
        console.log("No user is signed in.");
        window.location.href = "/sign-in";
      }
      setLoading(false);
    });
    return () => unsubscribeAuth();
  }, []);

  // Sign out
  const handleSignOut = async () => {
    try {
      await signOut(auth);
      window.location.href = "/sign-in";
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  // Theme handling
  const [theme, setTheme] = useState(() => {
    const storedTheme = localStorage.getItem("theme");
    return storedTheme ? storedTheme : "light";
  });

  useEffect(() => {
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  };

  // Sidebar collapse state (desktop)
  const [isCollapsed, setIsCollapsed] = useState(false);

  // Active section state
  const [activeSection, setActiveSection] = useState("home-section");

  if (loading) {
    return <Preloader />;
  }

  return (
    <div className="ce-dash-shell">
      {/* Top Navbar */}
      <Navbar
        userEmail={user.email}
        onSignOut={handleSignOut}
        theme={theme}
        toggleTheme={toggleTheme}
      />

      {/* Sidebar */}
      <Sidebar
        userEmail={user.email}
        onSignOut={handleSignOut}
        theme={theme}
        toggleTheme={toggleTheme}
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
        activeSection={activeSection}
        setActiveSection={setActiveSection}
      />

      {/* Main Content Area */}
      <div
        className={`
          transition-all duration-300 pt-0 lg:pt-16
          ${isCollapsed ? "lg:pl-[72px]" : "lg:pl-64"}
        `}
      >
        <main className="ce-dash-main">
          {activeSection === "home-section" && (
            <section id="home-section" className="px-4 py-4">
              <DashboardSection/>
              {/* <DBStructure/> */}
            </section>
          )}
         
          {activeSection === "support-section" && (
            <section id="export-section" className="px-4 py-4">
              <SupportSection/>
            </section>
          )}

          {activeSection === "settings-section" && (
            <section id="settings-section" className="px-4 py-4">
              <Settings/>
            </section>
          )}

          {activeSection === "institute-section" && (
            <section id="institute-section" className="px-4 py-4">
              <InstituteSection/>
            </section>
          )}

          {activeSection === "plans-section" && (
            <section id="plans-section" className="px-4 py-4">
              <PlansSection/>
            </section>
          )}
        </main>
      </div>
    </div>
  );
}

export default AdminDashboard;
